import axios from 'axios';
export function createCEOSubscriptionApi({ endpoints = {}, sessionToken } = {}) {
  const headers = sessionToken ? {Authorization:`Bearer ${sessionToken}`} : {};
  const get = async (url, signal) => (await axios.get(url,{headers,signal,timeout:30000})).data;
  return {
    loadSubscriptions: endpoints.load ? ({signal}) => get(endpoints.load,signal) : undefined,
    onGrantSubscription: endpoints.grant ? (payload,{requestId}) => axios.post(endpoints.grant,payload,{headers:{...headers,'Idempotency-Key':requestId},timeout:30000}).then(r=>r.data) : undefined,
    onRevokeGrant: endpoints.revoke ? (payload,{requestId}) => axios.post(endpoints.revoke,payload,{headers:{...headers,'Idempotency-Key':requestId},timeout:30000}).then(r=>r.data) : undefined,
  };
}
